import { render } from "./APlusIcon.vue?vue&type=template&id=9b855ec8"
import script from "./APlusIcon.vue?vue&type=script&lang=js"
export * from "./APlusIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__